import request from '../../utils/request'

// 获取视频号列表信息
export const getVideoList = (data) => {
  return request({
    url: `/api/admin/sys-config/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&keyword=${data.keyword}`,
    method: 'get'
  })
}

// 更新视频号信息
export const updateVideo = (data) => {
  return request({
    url: '/api/admin/sys-config/update',
    method: 'post',
    data
  })
}